import { toast } from 'sonner'

export function showFormValidationToast() {
	toast.error('กรุณาตรวจสอบข้อมูลที่จำเป็นให้ถูกต้องและครบถ้วน', {
		id: 'form-validation-error',
	})
}
